import { useEffect, useState } from "react";
import api, { resolveS3Url } from "./axios";

const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:8000/api";

/** Файлы из хранилища отдаются только авторизованному пользователю, поэтому
 *  <audio>/<img> не могут ссылаться на них напрямую: тег не передаёт токен.
 *  Файл скачивается запросом с авторизацией и подставляется как blob-URL. */
export function isProxiedUrl(url: string): boolean {
  return url.startsWith(`${API_BASE_URL}/s3/`);
}

export async function fetchS3ObjectUrl(url: string | null | undefined): Promise<string> {
  const resolved = resolveS3Url(url);
  // сторонние адреса не трогаем и токен им не отправляем
  if (!resolved || !isProxiedUrl(resolved)) return resolved;
  const res = await api.get(resolved, { responseType: "blob" });
  return URL.createObjectURL(res.data as Blob);
}

export function useS3ObjectUrl(url: string | null | undefined, enabled = true) {
  const [src, setSrc] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!url || !enabled) {
      setSrc("");
      return;
    }
    let cancelled = false;
    let objectUrl = "";
    setLoading(true);
    setError(false);
    fetchS3ObjectUrl(url)
      .then((result) => {
        if (result.startsWith("blob:")) objectUrl = result;
        if (cancelled) {
          if (objectUrl) URL.revokeObjectURL(objectUrl);
          return;
        }
        setSrc(result);
      })
      .catch(() => {
        if (!cancelled) setError(true);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [url, enabled]);

  return { src, loading, error };
}
